import * as React from "react";
import { Formik, Form, Field } from "formik";
import { Grid, Button, Typography, Card, CardContent } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import intl from "react-intl-universal";
import * as Yup from "yup";
import { useMutate } from "restful-react";
import { useSnackbar } from "notistack";

import { TextField } from "components/TextField";
import {
  sendResetEmail,
  ISendResetPasswordEmailInput,
  ISendResetPasswordEmailResponse,
} from "apis";

import { FIELD_EMAIL } from "./constants";

const useStyles = makeStyles((theme) => ({
  logoContainer: {
    display: "flex",
    justifyContent: "center",
    marginBottom: theme.spacing(2),
  },
  marginBottom: {
    marginBottom: theme.spacing(2),
  },
  button: {
    width: "100%",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  signup: {
    display: "flex",
    justifyContent: "center",
  },
}));

const initialValues = {
  [FIELD_EMAIL]: "",
};

export const ForgetPassword = () => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  const { mutate } = useMutate({
    verb: "POST",
    path: sendResetEmail(),
  });

  return (
    <Card>
      <CardContent>
        <div className={classes.logoContainer}>
          <Typography>
            <strong>{intl.get("FORGET_PASSWORD_TITLE")}</strong>
          </Typography>
        </div>
        <Formik
          initialValues={initialValues}
          validationSchema={Yup.object().shape({
            [FIELD_EMAIL]: Yup.string()
              .email(intl.get("FORM_VALIDATION_INVALID_EMAIL"))
              .required(intl.get("FORM_VALIDATION_REQUIRED")),
          })}
          onSubmit={async (values: any) => {
            const input: ISendResetPasswordEmailInput = {
              email: values[FIELD_EMAIL],
            };
            mutate(input).then(
              ({ errCode }: ISendResetPasswordEmailResponse) => {
                if (errCode > 0) {
                  enqueueSnackbar(
                    intl.get("SEND_RESET_PASSWORD_EMAIL_FAILED"),
                    {
                      variant: "error",
                    }
                  );
                  return;
                }
                enqueueSnackbar(intl.get("SEND_RESET_PASSWORD_EMAIL_SUCCESS"), {
                  variant: "success",
                });
              }
            );
          }}
        >
          {() => {
            return (
              <Form>
                <Grid container>
                  <Grid item xs={12}>
                    <Typography>
                      <strong>{`${intl.get("REGISTER_FORM_EMAIL")} *`}</strong>
                    </Typography>
                    <Field
                      component={TextField}
                      name={FIELD_EMAIL}
                      className={classes.marginBottom}
                    />
                  </Grid>
                  <Button
                    type="submit"
                    className={classes.button}
                    variant="contained"
                    color="secondary"
                    size="large"
                  >
                    {intl.get("FORGET_PASSWORD_SUBMIT")}
                  </Button>
                </Grid>
              </Form>
            );
          }}
        </Formik>
      </CardContent>
    </Card>
  );
};
